/*!
=========================================================
* 担当状況管理
=========================================================
*/
import React from "react";

import {
   Col,
  FormGroup,
} from "reactstrap";

import Request from '../../common/Request';
import ListBase from '../Base/ListBaseUnlimit'; // #1168-2021.7.15
import InputSelect from '../FormParts/InputSelect';
import OptionConvert from '../../common/OptionConvert';
import Format from '../../common/Format';

const domain = "";

class List extends ListBase {
  default_column = [
    { Header: '名前\n所属', accessor: 'USER__name', headerClassName: "text-center", className: "text-left text-top" ,width:150,minWidth:50 ,isSortDisabled:true},
    // { Header: '所属支店', accessor: 'USER_BRANCH__user_branch_name', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50},
    { Header: '未着手', accessor: 'SURVEY__COUNT_NO_YET', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '返答待ち', accessor: 'SURVEY__COUNT_WAITING_APPLY', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ﾁｪｯｸ', accessor: 'SURVEY__COUNT_CHECK', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ﾁｪｯｸOK', accessor: 'SURVEY__COUNT_CHECK_OK', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ﾁｪｯｸNG', accessor: 'SURVEY__COUNT_CHECK_NG', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '完了', accessor: 'SURVEY__COUNT_COMPLETE', headerClassName: "text-center", className: "text-right text-top" ,width:80,minWidth:50},

    { Header: '発注書待ち', accessor: 'PURCHASE_ORDER__COUNT_WAIT', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '調整中', accessor: 'PURCHASE_ORDER__COUNT_UNDER_ADJUSTMENT', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '完了', accessor: 'PURCHASE_ORDER__COUNT_COMPLETE', headerClassName: "text-center", className: "text-right text-top" ,width:80,minWidth:50},

    // { Header: '未着手', accessor: 'BLOCKMAP__COUNT_NO_YET', headerClassName: "text-center", className: "text-right text-top" ,width:80,minWidth:50},
    { Header: '区画図社内\nｱｯﾌﾟﾛｰﾄﾞ待ち', accessor: 'BLOCKMAP__COUNT_UP_WAIT', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '区画図\n依頼中', accessor: 'BLOCKMAP__COUNT_REQUEST', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: 'ｱｯﾌﾟﾛｰﾄﾞ済み', accessor: 'BLOCKMAP__COUNT_COMPLETE', headerClassName: "text-center", className: "text-right text-top" ,width:80,minWidth:50},

    { Header: '未着手', accessor: 'ORDER__COUNT_NOT_YET', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '保留', accessor: 'ORDER__COUNT_ON_HOLD', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '書類待ち', accessor: 'ORDER__COUNT_WAITING_DOCUMENTS', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '仕入', accessor: 'ORDER__COUNT_PURCHASE', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ﾁｪｯｸ', accessor: 'ORDER__COUNT_CHECK', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '承認', accessor: 'ORDER__COUNT_APPROVAL', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '納品', accessor: 'ORDER__COUNT_DELIVERYSLIP', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ｱｯﾌﾟﾛｰﾄﾞ待ち', accessor: 'ORDER__COUNT_WAITING_UPLOAD', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: 'ﾁｪｯｸ待ち', accessor: 'ORDER__COUNT_CHECK_WAITING', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    { Header: '調整中', accessor: 'ORDER__COUNT_UNDER_ADJUSTMENT', headerClassName: "text-center", className: "text-left text-top" ,width:80,minWidth:50,isSortDisabled:true},
    // { Header: '完了', accessor: 'ORDER__COUNT_COMPLETE', headerClassName: "text-center", className: "text-right text-top" ,width:80,minWidth:50},

  ];
  constructor(props) {
    super(props);

    Object.assign(this.state, {
      title: '担当状況管理',
      search_url: '/api/landmark/situation',
      column: this.default_column,
      valid: true,
      badge:false,
      searchData:{
        values:{},
        errors:{},
        requiredData:{}
      },
      show_detail_search_field:false,
      auto_scroll:true,
    });

    this.validateCallback = this.validateCallback.bind(this)
    this.search = this.search.bind(this)
    this.search_count = this.search_count.bind(this)
  }

  componentDidMount(){
    Request.get("/api/landmark/lastupdate",{}, res => {
      const user_list = OptionConvert.optionsById(res.Data)
      this.setState({landmark_user:user_list});
    })
    
    Request.get("/api/landmark/user_branch",{}, res => {
      const user_branch_list = res.Data.map((prop,key)=>{
        return {
            value:prop.user_branch_natural_id,
            label:prop.user_branch_name,
        }
      })
      this.setState({landmark_user_branch:user_branch_list});
    })

    this.search()

  }

  dataMap(data) {
    // console.log(data)
    return Object.keys(data).map((key) => {
      return {
        id: key,
        USER__name:(<>{data[key].name}<br />{data[key].user_branch_name}</>),
        USER_BRANCH__user_branch_name:data[key].user_branch_name,
        SURVEY__COUNT_NO_YET:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[0])}</>),
        SURVEY__COUNT_WAITING_APPLY:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[1])}</>),
        SURVEY__COUNT_CHECK:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[2])}</>),
        SURVEY__COUNT_CHECK_OK:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[3])}</>),
        SURVEY__COUNT_CHECK_NG:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[4])}</>),
        SURVEY__COUNT_COMPLETE:(<>調査：{Format.format_number_with_commas(data[key].request_box_status[5])}</>),

        PURCHASE_ORDER__COUNT_WAIT:(
          <>
          調査：{Format.format_number_with_commas(data[key].box_status_pobs_wsa[0])}<br />
          {/* 発注：{Format.format_number_with_commas(data[key].order_box_status[0])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[0])} */}
          </>
        ),
        // PURCHASE_ORDER__COUNT_UNDER_ADJUSTMENT:(<>
        //   調査：{Format.format_number_with_commas(data[key].box_status_pobs_wsa[1])}<br />
        //   {/* 発注：{Format.format_number_with_commas(data[key].order_box_status[1])}<br />
        //   仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[1])} */}
        //   </>),

        PURCHASE_ORDER__COUNT_COMPLETE:(<>
          調査：{Format.format_number_with_commas(data[key].box_status_pobs_wsa[2])}<br />
          発注：{Format.format_number_with_commas(data[key].order_box_status[2])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[2])}
        </>),

        ORDER__COUNT_NOT_YET:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[0])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[0])}
          </>),
        ORDER__COUNT_ON_HOLD:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[1])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[1])}
          </>),
        ORDER__COUNT_WAITING_DOCUMENTS:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[2])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[2])}
          </>),
        ORDER__COUNT_PURCHASE:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[3])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[3])}
          </>),
        ORDER__COUNT_CHECK:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[4])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[4])}
          </>),
        ORDER__COUNT_APPROVAL:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[5])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[5])}
          </>),
        ORDER__COUNT_DELIVERYSLIP:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[6])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[6])}
          </>),
        ORDER__COUNT_WAITING_UPLOAD:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[7])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[7])}
          </>),
        ORDER__COUNT_CHECK_WAITING:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[8])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[8])}
          </>),
        ORDER__COUNT_UNDER_ADJUSTMENT:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[9])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[9])}
          </>),
        ORDER__COUNT_COMPLETE:(<>
          発注：{Format.format_number_with_commas(data[key].order_box_status[10])}<br />
          仕入：{Format.format_number_with_commas(data[key].order_box_status_pay[10])}
          </>),

        BLOCKMAP__COUNT_NO_YET:(<>
          発注：{Format.format_number_with_commas(data[key].box_status_lpprs_con[0])}<br />
          仕入：{Format.format_number_with_commas(data[key].box_status_lpprs_pay[0])}
          </>),

        BLOCKMAP__COUNT_UP_WAIT:(<>
          発注：{Format.format_number_with_commas(data[key].box_status_lpprs_con[1])}<br />
          仕入：{Format.format_number_with_commas(data[key].box_status_lpprs_pay[1])}
          </>),

        BLOCKMAP__COUNT_REQUEST:(<>
          発注：{Format.format_number_with_commas(data[key].box_status_lpprs_con[2])}<br />
          仕入：{Format.format_number_with_commas(data[key].box_status_lpprs_pay[2])}
          </>),

        BLOCKMAP__COUNT_COMPLETE:(<>
          発注：{Format.format_number_with_commas(data[key].box_status_lpprs_con[3])}<br />
          仕入：{Format.format_number_with_commas(data[key].box_status_lpprs_pay[3])}
          </>),


        }
    });
  }

  search_params() {
    const {values} = this.state.searchData
    return values&&Object.keys(values).reduce((acc, key)=>{
      if (values[key]){
        acc[key] = values[key]
      }
      return acc
    },{})
  }

  add_field_cols() {
  }

  search() {
    /* ここは開発者が記述 */
    if (!this.validate()) {
        // do nothing
        return;
    }
    this.search_count();
    var searchParmas = this.search_params()
    searchParmas["pager_index"] = "0";
    searchParmas["pager_limit"] = this.state.paging["limit"];
    Request.get(this.state.search_url, 
      searchParmas
      , res => {
        this.setState({
          paging: {
            "index": parseInt(searchParmas["pager_index"]),
            "limit": parseInt(searchParmas["pager_limit"])
          },  
          data: this.dataMap(res.Data)
        });
    })

  }
  search_count() {
    var search_param = this.search_params();
    search_param["data_count"] = 1;
    Request.get(this.state.search_url, search_param, res => {
        // console.log(res.data);
        this.setState({data_count: res.Data});
    })    
  }

  validate() {
    return Object.keys(this.state.searchData.errors).length===0;
  }

  validateCallback(newData, callback=()=>{}){
    this.setState({
      searchData:{
        ...this.state.searchData,
        ...newData
      }
    }, ()=>callback())
  }
  
  search_field_cols() {
    return (
      <>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label='名前'
              name='USER__id'
              labelOn={true}
              options={this.state.landmark_user}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              isSearchable={true}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <InputSelect
              label='ランドマーク支店'
              name='USER_BRANCH__user_branch_natural_id'
              labelOn={true}
              options={this.state.landmark_user_branch}
              validateCallback={this.validateCallback}
              rootData={this.state.searchData}
              isSearchable={true}
              validateType={'search'}
            />
          </FormGroup>
        </Col>
      </>
    );
  }
}

export default List;
